import React from 'react'
import { useViewport } from '@chilecompra/react-kit'
import { PUBLIC_URL, REACT_APP_MERCADO_PUBLICO_BASE_URL } from '../../config/settings/environment'
import { Column, Link, Logo, Root, Row, Button } from './HeaderSection.styles'
import PropTypes from 'prop-types'

/**
 * The HeaderSection's container.
 */
const HeaderSection = ({ showBackButton }) => {
  const { size } = useViewport()

  const goDesktop = () => {
    const url = `${REACT_APP_MERCADO_PUBLICO_BASE_URL}/Portal/Modules/Menu/Menu.aspx`
    location.href = url
  }

  return (
    <Root>
      <Row alignItems="center">
        <Column xs={12} container alignItems="center">
          <Link to="#">
            <Logo
              alt="Mercado Público"
              isDownToSmall={size.isDownToSmall}
              src={`${PUBLIC_URL}/assets/images/logo_mercadopublico.svg`}
            />
          </Link>
          {showBackButton && (
            <Button variant="outlined" color="default" onClick={goDesktop}>
              Volver al inicio
            </Button>
          )}
        </Column>
      </Row>
    </Root>
  )
}

HeaderSection.defaultProps = {
  showBackButton: null
}

HeaderSection.propTypes = {
  showBackButton: PropTypes.bool
}

export default HeaderSection
